export class PaginationData {
  constructor(page: number, selected: boolean) {
    this.page = page;
    this.selected = selected;
  }

  public page: number;
  public selected: boolean;
}
